import { useState, useEffect } from 'react'
import { usePage } from '@inertiajs/react'
import consumer from '@/channels/consumer'

export function useUnreadMessagesChannel() {
  const { unread_messages_count } = usePage().props as any
  const [unreadCount, setUnreadCount] = useState<number>(unread_messages_count ?? 0)

  // Sync with Inertia props when they change (page navigation)
  useEffect(() => {
    setUnreadCount(unread_messages_count ?? 0)
  }, [unread_messages_count])

  // Subscribe to real-time updates via ActionCable
  useEffect(() => {
    const subscription = consumer.subscriptions.create(
      { channel: 'Messages::UnreadCountChannel' },
      {
        received(message: any) {
          if (message.type === 'unread_count_changed') {
            setUnreadCount(message.unread_count)
          }
        },
      }
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [])

  return unreadCount
}
